type CohortSectionHeaderProps = {
  id: string
  eyebrow?: string
  headline: string
}

export const CohortSectionHeader = ({
  id,
  eyebrow,
  headline,
}: CohortSectionHeaderProps) => (
  <div className='flex flex-col items-center gap-5 text-center'>
    {eyebrow && <p className='c-caption-mono m-0'>{eyebrow}</p>}
    <h2 id={id} className='c-d-1 m-0 lg:w-8/12'>
      {headline}
    </h2>
  </div>
)
